import { Injectable } from '@angular/core';

import { StorageAPIService } from '../storage-api.service';
import { EnableClassTelemetry } from '../../services/otel.service';
import { urlFor } from './utils';

export interface NewspaperSmartSummaryResponse {
  text: string;
}

@EnableClassTelemetry()
@Injectable({ providedIn: 'root' })
export class NewspaperService extends StorageAPIService {
  public postNewspaperSmartSummary(
    collectionName: string,
    analysisGroupId: string,
    analysisId: string,
    timezone: string,
    scene: string,
    query: string,
    projectId?: string
  ): Promise<NewspaperSmartSummaryResponse> {
    let url: string;
    if (analysisId) {
      url = urlFor(
        `/collections/${encodeURIComponent(collectionName)}/analyses/${encodeURIComponent(
          analysisId
        )}/smart-summary`,
        projectId
      );
    } else {
      url = urlFor(
        `/analysis-groups/${encodeURIComponent(analysisGroupId)}/smart-summary`,
        projectId
      );
    }

    return this.post<NewspaperSmartSummaryResponse>(url, {}, {}, { query, timezone, scene });
  }
}
